import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { api } from '../../../lib/api-client';
import { type DocumentSummary } from '../../../lib/types';

interface UseDocumentsResult {
  documents: DocumentSummary[];
  isLoading: boolean;
  error: Error | null;
  refetch: () => void;
}

/**
 * Lista Documents filtrados pelo bondId da conversa atual.
 * Backend filtra: Bond direto + conversas do bond + Documents sem ACL formal.
 *
 * Item 36 (PR-B2). staleTime 30s para reaproveitar entre re-abertura do Picker.
 */
export function useDocuments(bondId: string | undefined, search?: string): UseDocumentsResult {
  const query: UseQueryResult<
    { data: DocumentSummary[]; nextCursor: string | null; hasMore: boolean },
    Error
  > = useQuery({
    queryKey: ['documents', 'picker', bondId, search ?? ''],
    queryFn: async () => {
      if (bondId === undefined) {
        return { data: [], nextCursor: null, hasMore: false };
      }
      return api.listDocuments({
        bondId,
        ...(search !== undefined && search.length > 0 && { search }),
        limit: 50,
      });
    },
    enabled: bondId !== undefined,
    staleTime: 30_000,
  });

  return {
    documents: query.data?.data ?? [],
    isLoading: query.isLoading,
    error: query.error,
    refetch: () => void query.refetch(),
  };
}
